import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { InvoiceTrackingResponseModel } from 'src/app/model/InvoiceTrackingResponseModel';
import { Page } from 'src/app/model/Page';
import { MasterService } from 'src/app/services/master.service';

@Component({
  selector: 'app-secure-invoice-tracking',
  templateUrl: './invoice-tracking.component.html',
  styleUrls: ['./invoice-tracking.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InvoiceTrackingComponent implements OnInit {

  page: Page<InvoiceTrackingResponseModel>;
  dataSource: MatTableDataSource<InvoiceTrackingResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100,1000];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  boardList: { [key: number]: string };

  public lotteryList: { [key: number]: string };

  public schemeList: { [key: number]: string };
  isSubmitDisabled: boolean = true;

  stageValue: number;
  stageName: string;
  isLoadingAfterSave = false;

  boardKey: number;
  selectAllChecked: boolean = false;
  isTableShow: boolean = true;
  lotteryKey: number;
  data: InvoiceTrackingResponseModel;
  key: number;
  applicationId: number;
  stageNo: number;
  invoiceNo: string;
  tenementId: number;
  invoiceStatus: string;
  // selectedElement: InvoiceTrackingResponseModel | null = null;
  selectedElements: InvoiceTrackingResponseModel[] = [];

  // selectedElement: InvoiceTrackingResponseModel | null = null;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  stageList: any[] = [
    { name: "1 - Verification of documents", value: "1" },
    { name: "2 - POL Issued", value: "2", },
    { name: "3 - Operate Waitlist & LOI", value: "3" },
    { name: "4 - Demand Issued", value: "4" },
    { name: "5 - Allotment Issued", value: "5" },
    { name: "6 - Possession & Keyhandover", value: "6" },
  ];
  displayedColumns: string[] = [
    "id",
    "checkbox",
    "schemeCode",
    "tenementDetails",
    "applicationNo",
    "name",
    "drawStatus",
    "currentStatus",
    "currentStage",
    "previousStage"
  ];
  count: any;
  formGroup: any;
  dialogRef: any;
  http: any;

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar) { }

  ngOnInit(): void {

    this.filterForm = new FormGroup({
      boardFilter: new FormControl(null, [Validators.required]),
      lotteryFilter: new FormControl(null, [Validators.required]),
      stageNumberFilter: new FormControl(null, [Validators.required]),
      stageStatusFilter: new FormControl(null, [Validators.required]),
    });
    
    this.onLoad();
  }

  onLoad() {
    //this.isLoading=true;
    this.masterService.getAllBoardForInvoice().subscribe((data) => {
      console.log(data);
      this.boardList = data.boards;
      this.isLoading = false;

    });
  }

  onStatusChange(value: any) {
    this.invoiceStatus = value;
  }
  
  onChangeBoard(key: any) {
    console.log('Hello', key);
    this.isTableShow = false;
    this.boardKey = key;
    this.masterService.getLotteryForInvoice(key).subscribe((data) => {
      console.log(data);
      this.lotteryList = data.lottery;
      this.filterForm.get('lotteryFilter').setValue(null);
      this.filterForm.get('stageNumberFilter').patchValue(null);// TODO
      
    });
  }

  onChangeLottery(key: any) {
    this.isTableShow = false;
    this.lotteryKey = key;
    this.filterForm.get('stageNumberFilter').setValue(null);

  }

  getStageName(value: any): string {
    const stage = this.stageList.find(stage => stage.value === value);
    return stage ? stage.name : '';
  }

  onChangeForStage(value: any, name: any) {
    console.log("name+++++++++", name)
    this.stageValue = value;
    this.stageName = name;
    this.currentPage = 0;
    this.onSearchForDashboard();
  }

  onSearchForDashboard() {
    this.isSubmitDisabled = true;
    this.isLoading = true;
    this.isTableShow = false;
    console.log("onSearchForDashboard", this.lotteryKey);
    this.dataSource = new MatTableDataSource();
    this.masterService.initInvoice(this.currentPage, this.pageSize,this.boardKey, this.lotteryKey, this.stageValue,
      this.invoiceStatus).subscribe((data) => {
        this.isLoading = false;
        this.isTableShow = true;
        console.log(data);
        this.page = data;

        this.dataSource = new MatTableDataSource(this.page.content);
        this.selectAllChecked = false;
        this.selectedElements = [];

        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = this.page.totalElements;
        });
      },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isTableShow = true;
          // this.isSearchDisabled = false;
        });
  }


  selectAllCheckbox() {
    if (this.selectAllChecked) {
      this.dataSource.data.forEach((element) => {
        element.isSelected = true;
        if (!this.selectedElements.includes(element)) {
          this.selectedElements.push(element);
          console.log(this.selectedElements);
        }
      });
    } else {
      this.dataSource.data.forEach((element) => {
        element.isSelected = false;
        const index = this.selectedElements.indexOf(element);
        // this.selectAllChecked=null;
        if (index !== -1) {
          this.selectedElements.splice(index, 1);
          console.log(this.selectedElements);
        }
      });
    }
    this.updateSubmitButtonStatus();
  }
  
  onCheckboxChange(row: InvoiceTrackingResponseModel) {
    if (row.isSelected) {
      this.selectedElements.push(row);
    } else {
      const index = this.selectedElements.findIndex(element => element === row);
      if (index !== -1) {
        this.selectedElements.splice(index, 1);
      }
    }
    console.log("this.selectedElements", this.selectedElements);
    this.updateSubmitButtonStatus();
  }

  updateSubmitButtonStatus() {
    this.isSubmitDisabled = this.selectedElements.length === 0;
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.pageSize = 10;
      this.currentPage = 0;
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 2 char) ",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  openModal() {
    this.isSubmitDisabled = false;
    this.saveInvoiceDetails();
    this.onSearchForDashboard();
  }

  saveInvoiceDetails() {
    this.isLoading = true;
    let payload: any = {
      // key: this.key,
      // applicationId: this.applicationId,
      // stageNo: this.stageNo,
      // invoiceNo: this.invoiceNo,
      // tenementId:this.tenementId,
      // invoiceStatus: this.invoiceStatus,
      stageName: this.stageName,
      selectedElements: this.selectedElements
    }

    this.masterService.saveInvoiceDetails(payload).subscribe(
      (data: any) => {
        if (data.status === "SUCCESS") {
          this.successToast();
          this.isLoadingAfterSave = true;

          this.onSearchForDashboard(); // TODO

        } else {
          this.isSubmitDisabled = false;
          this.isLoadingAfterSave = true;
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isSubmitDisabled = false;
        console.log(error);
        // this.errorToast(error.error.errorMessage, 5 * 1000);
        this.errorToast("Bill for stage of tenement has already been generated", 5 * 1000);
      }
    );

    this.onLoad();
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onSearchForDashboard();
  }

  resetFilter() {
    this.boardKey = null; 
    this.lotteryKey = null; 
    this.stageValue = null;
    this.filterForm.controls["boardFilter"].setValue(null);
    this.filterForm.controls["lotteryFilter"].setValue(null);
    this.filterForm.controls["stageNumberFilter"].setValue(null);
    this.filterForm.controls["stageStatusFilter"].setValue(null);
    this.onSearchForDashboard();
  }

  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if (status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if (status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if (status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  showObj(o1: any, o2: any) {
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  routeToForm() {
    this.router.navigate(["/secure", "invoice-tracking", "form"]);
  }

  routeToGeneratedInvoice() {
    this.router.navigate(["/secure", "invoice-tracking", "generated-invoice"]);
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
  async successToast() {
    await this._snackBar.open("Invoice Details saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

}
